// extracted by mini-css-extract-plugin
export default {"banner":"Jhwm1AIesmUMqpSh3M2X"};